import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, Field } from "./Login";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await register(form.email.trim(), form.password, form.name.trim());
    setSubmitting(false);
    if (res.ok) {
      navigate("/app", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <AuthShell title="Start writing." subtitle="7 days on us. No card. No tricks.">
      <form onSubmit={handleSubmit} className="space-y-5" data-testid="signup-form">
        <Field label="Your name">
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            autoComplete="name"
            data-testid="signup-name"
            className="w-full bg-transparent border-b border-[var(--line)] focus:border-[var(--brand)] outline-none py-2 text-base"
          />
        </Field>
        <Field label="Email">
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            autoComplete="email"
            data-testid="signup-email"
            className="w-full bg-transparent border-b border-[var(--line)] focus:border-[var(--brand)] outline-none py-2 text-base"
          />
        </Field>
        <Field label="Password (8+ characters)">
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="signup-password"
            className="w-full bg-transparent border-b border-[var(--line)] focus:border-[var(--brand)] outline-none py-2 text-base"
          />
        </Field>
        {error && <p className="text-sm text-[var(--err)]" data-testid="signup-error">{error}</p>}
        <button type="submit" disabled={submitting} className="btn-brand w-full disabled:opacity-60" data-testid="signup-submit">
          {submitting ? "Setting up your trial…" : "Start writing — 7 days free"}
        </button>
        <p className="text-xs text-[var(--ink-muted)] text-center" data-testid="signup-fineprint">
          By signing up you agree to be a person who writes things.
        </p>
        <div className="text-center text-sm">
          <Link to="/login" className="text-[var(--ink-secondary)] hover:text-[var(--ink-primary)]" data-testid="signup-login-link">
            Already have an account? Sign in
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}
